/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Magnified_Download_TitleInputs */

const en_video_export_magnified_download_title = /** @type {(inputs: Video_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Preview Thumbnail`)
};

const fr_video_export_magnified_download_title = /** @type {(inputs: Video_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telecharger la miniature de previsualisation`)
};

const de_video_export_magnified_download_title = /** @type {(inputs: Video_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau herunterladen (Miniaturansicht)`)
};

const it_video_export_magnified_download_title = /** @type {(inputs: Video_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica Anteprima Miniatura`)
};

const ru_video_export_magnified_download_title = /** @type {(inputs: Video_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать Предварительный просмотр Миниатюра`)
};

const es_video_export_magnified_download_title = /** @type {(inputs: Video_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar vista previa en miniatura`)
};

const zh_cn2_video_export_magnified_download_title = /** @type {(inputs: Video_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载预览缩略图`)
};

const ja_video_export_magnified_download_title = /** @type {(inputs: Video_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューサムネイルをダウンロード`)
};

const hi_video_export_magnified_download_title = /** @type {(inputs: Video_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्वावलोकन थंबनेल डाउनलोड करें`)
};

const pt_pt2_video_export_magnified_download_title = /** @type {(inputs: Video_Export_Magnified_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixar miniatura de pré-visualização`)
};

/**
* | output |
* | --- |
* | "Download Preview Thumbnail" |
*
* @param {Video_Export_Magnified_Download_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_magnified_download_title = /** @type {((inputs?: Video_Export_Magnified_Download_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Magnified_Download_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_magnified_download_title(inputs)
	if (locale === "de") return de_video_export_magnified_download_title(inputs)
	if (locale === "it") return it_video_export_magnified_download_title(inputs)
	if (locale === "ru") return ru_video_export_magnified_download_title(inputs)
	if (locale === "es") return es_video_export_magnified_download_title(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_magnified_download_title(inputs)
	if (locale === "ja") return ja_video_export_magnified_download_title(inputs)
	if (locale === "hi") return hi_video_export_magnified_download_title(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_magnified_download_title(inputs)
	return en_video_export_magnified_download_title(inputs)
});